import wxSdk from 'weixin-js-sdk'  //h5分享用到
import axios from "axios";

import $ from 'jquery'
var Shares = {
  // h5分享功能
  shareCode: function (imgurl, title, desc, link, callback,) {
    var url = window.location.href.split('#')[0]
    $.ajax({
      type: "post",
      dataType: 'text',
      // url: "/api/service/data/Handler.ashx/getfxdata?danurl=" + url,
      url: "https://xztys.goldweb.cn/service/data/Handler.ashx/getfxdata?danurl=" + url,
      async: false,
      success: function (data) {
        var obj = $.parseJSON(data);
        wxSdk.config({
          debug: false,
          appId: obj.appId,
          timestamp: obj.timestamp,
          nonceStr: obj.nonceStr,
          signature: obj.signature,
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',

            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone'
          ]
        });
        wxSdk.ready(function () {
          let shareData = {
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgurl, // 分享图标
          };
          wxSdk.updateAppMessageShareData(shareData);
          wxSdk.updateTimelineShareData(shareData);

          wxSdk.onMenuShareAppMessage(shareData); //分享给好友
          wxSdk.onMenuShareTimeline(shareData); //分享到朋友圈
          wxSdk.onMenuShareQQ(shareData); //分享给手机QQ
          wxSdk.onMenuShareWeibo(shareData); //分享腾讯微博
          wxSdk.onMenuShareQZone(shareData); //分享到QQ空间
        });
      },
      error: function (data) {
      }
    });
  }
}
export {
  Shares
}